module.exports = __webpack_public_path__ + "img/Bill.d2b444bf.png";